import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import { types as sdkTypes } from '../../util/sdkLoader';
import Button from '../../components/Button/Button';
import Carousel from 'react-multi-carousel';
import classNames from 'classnames';

import { NamedLink } from '../../components';

import css from './SectionParkingSpots.module.css';

const sharetribeSdk = require('sharetribe-flex-sdk');
const { UUID } = sdkTypes;

const sdkUtil = sharetribeSdk.util;
const sdk = sharetribeSdk.createInstance({
  clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID
});

const SectionParkingSpots = props => {
  const { rootClassName, className, history } = props;
  const [listingsJsonsArray, setListingsJsonsArray] = useState([]);


  useEffect(() => {
   const listingsIdsArray = ["6166d512-e995-45ce-b1fd-2c75a53edb5a", "6166eddc-4d2a-401c-aecb-975368c9b4d1", "6166e6dc-a60a-49f2-85eb-5f1b8d163eff"];  // add id's of listing here like this "60b5d66c-5d04-4dd6-9be2-06d8d154016d"

   if(typeof window === "undefined"){
    console.log("ceva")
   }else{
    require('react-multi-carousel/lib/styles.css');
  
   }

   const promisesArray = listingsIdsArray.map(listingId => {
    return sdk.listings.show({id: listingId,
       include: ['author', 'images'],
       "fields.image": ["variants.square-small", "variants.my-variant"],
       "imageVariant.my-variant": sdkUtil.objectQueryString({
         w: 320,
         h: 640,
         fit: 'scale'
       }),
   
     }).then(resp => {
       const listingPicture = resp.data.included[1].attributes.variants["my-variant"].url;
       const listingPrice = resp.data.data.attributes.price.amount / 100;
       const listingTitle = resp.data.data.attributes.title;
       const listingHost = resp.data.included[0].attributes.profile.displayName;
       
     return {
        listingId: listingId,
         pictureLink: listingPicture,
         listingPrice: listingPrice,
         listingTitle: listingTitle,
         listingHost: listingHost
       } 
      
     }).catch(error => console.log(error.stack))
 });

 
       Promise.all(promisesArray).then(resp => {
          // console.log("3#")
          // console.log("array with all the closed dates that we just fetched from external source")
          // console.log(resp.flat())
          const flattenJustFetchedDatesArray = resp.flat();
          return setListingsJsonsArray(flattenJustFetchedDatesArray)
        }).catch(error => {
          console.log(error.stack)
        })



  }, []);

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  const classes = classNames(rootClassName || css.root, className);
  console.log(listingsJsonsArray)
  return (
    <div className={classes}>
      <div className={css.title}>
      <span className={css.leftTitle}>Ces parkings</span> <FormattedMessage id="SectionParkingSpots.title" />
      <p className={css.underTitle}>N’attendez plus et <span className={css.blueText}>réservez votre ollo</span> dès maintenant.</p>
      </div>

      <Carousel
       responsive={responsive}
       swipeable={true}
       draggable={true}
       arrows={true}
       showDots={false}
       ssr={false} // means to render carousel on server-side.
       keyBoardControl={false}
       >
        {
          listingsJsonsArray.map(listing => {
            return(
              <div className={css.listingCard} onClick={() => history.push(`/l/${listing.listingTitle}/${listing.listingId}`)}>
                  <img src={listing.pictureLink} className={css.listingCardImage}/>
                  <div className={css.listingInfo}>
                      <div className={css.listingInfoPrice}>
                            <span><span className={css.priceNumber}>{listing.listingPrice}</span><span className={css.priceCurrency}>€</span></span>
                            <span>par jour</span>
                      </div>
                      <div className={css.listingInfoDetails}>
                          <span className={css.listingTitle}>{listing.listingTitle}</span>
                          <span className={css.listingHost}>{listing.listingHost}</span>
                          
                      </div>
                  </div>
              </div>
            )
          })
        }
     </Carousel>
      
        <Button
         className={css.parkingSpotsButton}
         onClick={() => history.push('/s?address=Paris%2C%20France&bounds=48.9020129995121%2C2.46976999462145%2C48.8156060108013%2C2.22422400085346')}
         >Trouvez la place qu’il vous faut</Button>
    </div>
  );
};

SectionParkingSpots.defaultProps = { rootClassName: null, className: null };

const { string } = PropTypes;

SectionParkingSpots.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionParkingSpots;
